import { render, staticRenderFns } from "./CommunicationModal.vue?vue&type=template&id=6e985093&"
import script from "./CommunicationModal.vue?vue&type=script&lang=js&"
export * from "./CommunicationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports